import { lazy } from "react";
import { Outlet } from "react-router";
import { RoleGuard } from "../contexts/RoleGuard";
import { AuthGuard } from "../utils/AuthGuard";
import { ScreenLoader } from "../utils/ScreenLoader";

const SellerList = ScreenLoader(lazy(() => import("../screens/seller-screen/SellerList")));

const SellerListV2 = ScreenLoader(lazy(() => import("../screens/seller-screen/SellerListV2")));

const SellerListDaily = ScreenLoader(
  lazy(() => import("../screens/seller-screen/SellerListDaily")),
);

const SellerListDailyV2 = ScreenLoader(
  lazy(() => import("../screens/seller-screen/SellerListDailyV2")),
);

const SellerCreate = ScreenLoader(lazy(() => import("../screens/seller-screen/SellerCreate")));

const SellerReport = ScreenLoader(lazy(() => import("../screens/seller-screen/SellerReport")));

const SellerReportDaily = ScreenLoader(
  lazy(() => import("../screens/seller-screen/SellerReportDaily")),
);

const SellerReportDailyV2 = ScreenLoader(
  lazy(() => import("../screens/seller-screen/SellerReportDailyV2")),
);

const SellerUserList = ScreenLoader(lazy(() => import("../screens/seller-screen/SellerUserList")));

const SellerUserListV2 = ScreenLoader(
  lazy(() => import("../screens/seller-screen/SellerUserListV2")),
);

const SellerChangePassword = ScreenLoader(
  lazy(() => import("../screens/seller-screen/SellerChangePassword")),
);

const SellerMoveUser = ScreenLoader(lazy(() => import("../screens/seller-screen/SellerMoveUsers")));
//maping the seller route completely
export const SellerRoute = () => ({
  path: "seller",
  element: (
    <AuthGuard>
      <Outlet />
    </AuthGuard>
  ),
  children: [
    {
      path: "list",
      element: (
        <RoleGuard requiredPermission="sellerManagement" requiredActions={["isRead"]}>
          <SellerList />
        </RoleGuard>
      ),
    },
    {
      path: "list-v2",
      element: (
        <RoleGuard requiredPermission="sellerManagement" requiredActions={["isRead"]}>
          <SellerListV2 />
        </RoleGuard>
      ),
    },
    {
      path: "create",
      element: (
        <RoleGuard requiredPermission="sellerManagement" requiredActions={["isCreate"]}>
          <SellerCreate />
        </RoleGuard>
      ),
    },
    {
      path: "update/:id",
      element: (
        <RoleGuard requiredPermission="sellerManagement" requiredActions={["isUpdate", "isRead"]}>
          <SellerCreate />
        </RoleGuard>
      ),
    },
    {
      path: "report/:id",
      element: (
        <RoleGuard requiredPermission="sellerManagement" requiredActions={["isRead"]}>
          <SellerReport />
        </RoleGuard>
      ),
    },
    {
      path: "daily",
      element: (
        <RoleGuard requiredPermission="sellerManagement" requiredActions={["isRead"]}>
          <SellerListDaily />
        </RoleGuard>
      ),
    },
    {
      path: "daily-v2",
      element: (
        <RoleGuard requiredPermission="sellerManagement" requiredActions={["isRead"]}>
          <SellerListDailyV2 />
        </RoleGuard>
      ),
    },
    {
      path: "daily-report/:id",
      element: (
        <RoleGuard requiredPermission="sellerManagement" requiredActions={["isRead"]}>
          <SellerReportDaily />
        </RoleGuard>
      ),
    },
    {
      path: "daily-report-v2/:id",
      element: (
        <RoleGuard requiredPermission="sellerManagement" requiredActions={["isRead"]}>
          <SellerReportDailyV2 />
        </RoleGuard>
      ),
    },
    {
      path: "user/:id",
      element: (
        <RoleGuard requiredPermission="sellerManagement" requiredActions={["isRead"]}>
          <SellerUserList />
        </RoleGuard>
      ),
    },
    {
      path: "user-v2/:id",
      element: (
        <RoleGuard requiredPermission="sellerManagement" requiredActions={["isRead"]}>
          <SellerUserListV2 />
        </RoleGuard>
      ),
    },
    {
      path: "move-user/:id",
      element: (
        <RoleGuard requiredPermission="sellerManagement" requiredActions={["isRead", "isUpdate"]}>
          <SellerMoveUser />
        </RoleGuard>
      ),
    },
    {
      path: "change-password/:id",
      element: (
        <RoleGuard requiredPermission="sellerManagement" requiredActions={["isRead", "isUpdate"]}>
          <SellerChangePassword />
        </RoleGuard>
      ),
    },
  ],
});
